import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { RequestCache } from '../../interceptors/cache-interceptor';
import { LanguagesService } from '../../services/languages.service';
import { BaseResponse, GDPR } from 'src/app/interfaces/utilities';
import { map } from 'rxjs/operators';
import { UsersService } from 'src/app/services/user.service';
import { showSuccessOrErrorToast, checkResponse } from 'src/app/utilities/utilities';
import { Profilo } from 'src/app/interfaces/user';
import { BsModalRef } from 'ngx-bootstrap';
import { EditionService } from 'src/app/services/edition.service';
import { RegolamentoEdizione } from 'src/app/interfaces/edition';
import { forkJoin } from 'rxjs';
import { faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';

@Component({
	selector: 'sanremo-gdpr',
	templateUrl: './gdpr.component.html',
	styleUrls: ['./gdpr.component.css']
})
export class GdprComponent implements OnInit {

	gdpr: string;
	regolamento: string;
	informativa: string;
	title: string;
	isAccepted = false;
	isChecked = false;
	isCollapsed = true;
	faSort = faSortUp;
	accept_terms_conditions = this.languageService.getValue("accept_terms_conditions")
	isCheckedTerms = false;

	constructor(
		private languageService: LanguagesService,
		private toastrService: ToastrService,
		private usersService: UsersService,
		private editionService: EditionService,
		private requestCache: RequestCache,
		private router: Router,
		public bsModalRef: BsModalRef
	) { }

	ngOnInit() {
		forkJoin(
			this.getInformativa(),
			this.getRegolamento()
		  ).subscribe((data) => {
			this.informativa = `<p>${data[0]}</p>`;
			this.regolamento = `<p>${data[1]}</p>`
		  });
	}


	getInformativa() {
		return this.usersService.getGdpr().pipe(
			map((response: GDPR) => checkResponse(response, this.toastrService, "gdpr"))
		)
	}

	getRegolamento(){
		return this.editionService.getRegolamentoEdizione().pipe(
			map((response: RegolamentoEdizione) => checkResponse(response, this.toastrService, "regolamento"))
		)
	}

	toggleVisibility(e){
    this.isChecked = e.target.checked;
	console.log(this.isChecked);
  }
	toggleVisibilityTerms(e){
    this.isCheckedTerms = e.target.checked;
	console.log(this.isCheckedTerms);
  }
	
	toggleSortIcon() {
		this.faSort = this.faSort == faSortDown ? faSortUp : faSortDown;
	}

	iconClass() {
		return {
			"sort-down": this.faSort == faSortDown,
			"sort-up": this.faSort != faSortDown
		};
	}

	accept(): void {
		this.isAccepted = true;
		this.bsModalRef.hide();
		return;
	}
}
